module.exports = __webpack_public_path__ + "img/icon9.86ddd70d.png";